export const cools = [
    "ABC",
    "Boomer",
    "Boomerang",
    "Boss",
    "Budweiser",
    "Buster",
    "Butch",
    "Buzz",
    "Champ",
    "Coma",
    "Diesel",
    "Doctor",
    "Froggy",
    "General",
    "Godzilla",
    "Indominus",
    "KingKong",
    "Mastadon",
    "Master",
    "Ratman",
    "Sentinel",
    "Speed",
    "Spike",
    "Subwoofer",
    "Tornado",
    "Vice",
    "Viper",
    "Wasp",
    "Wizard",
    "Zodiac",
    "Mercury",
    "Venus",
    "Earth",
    "Mars",
    "Jupiter",
    "Saturn",
    "Uranus",
    "Neptune",
    "Player",
    "User",
    "Lotus",
    "Lily",
    "Sunflower",
    "Rose",
    "Football",
    "Cowboy",
    "Ninja",
    "Racer",
    "Rookie",
    "Turbo",
    "Birdie",
    "Kitty",
    "Panda",
    "Tiger",
    "Lion",
    "Dolphin",
    "Coffee",
    "Honey"
];
